/**
 * 'Vertrouwensniveaus' options
 */
export enum ClearancelevelEnum {
    /**
     * lowest clearance so most accessible
     */
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4,
    Five = 5,
}
/**
 * An Array of all available Clearance level values
 */
export const ClearanceLevels: ClearancelevelEnum[] = [ClearancelevelEnum.One, ClearancelevelEnum.Two, ClearancelevelEnum.Three, ClearancelevelEnum.Four, ClearancelevelEnum.Five];